/**
 * Boolean UI preferences (collapsed panels, ...) kept in localStorage.
 * Storage can be unavailable (private mode, blocked site data) or throw, so
 * every access is guarded: the UI just falls back to the default and the
 * preference doesn't persist.
 */
export function readFlag(key: string, fallback = false): boolean {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value === '1';
  } catch {
    return fallback;
  }
}

export function writeFlag(key: string, value: boolean): void {
  try {
    window.localStorage.setItem(key, value ? '1' : '0');
  } catch {
    // Storage unavailable: the preference is session-only.
  }
}
